import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { OauthService } from '@app/core/services/oauth.service';
import { PlatformService } from '@app/core/services/platform.service';
import { RestaurantService } from '@app/core/services/restaurant.service';
import { IOrder } from '@app/data/models/IOrder';
import { IRestaurant } from '@app/data/models/IRestaurant';
import { LayoutService } from '@app/layout/services/layout.service';
import { ModalSessionSigninComponent } from '@app/shared/components/session-modals/signin/signin.component';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { filter, tap } from 'rxjs';
import { environment } from 'src/environments';

@UntilDestroy()
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [TranslateModule, RouterLink, NgbCollapse],
})
export class SidebarComponent implements OnInit {
  loggedIn = false;
  urlToken: any = null;
  currentOrder: IOrder = null;
  currentView: string = this.router.url;

  private idLocation: number;
  private restaurant: IRestaurant;

  constructor(
    private $layout: LayoutService,
    private router: Router,
    private $modal: NgbModal,
    private $oauth: OauthService,
    private $restaurant: RestaurantService,
    private $platform: PlatformService,
    private $toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        untilDestroyed(this),
        tap((event: NavigationEnd | any) => {
          if (event instanceof NavigationEnd) {
            this.currentView = event.url;
          }
        })
      )
      .subscribe();

    this.$oauth.loggedIn$
      .pipe(
        tap((loggedIn: boolean) => {
          this.loggedIn = loggedIn;
        })
      )
      .subscribe();

    this.$restaurant.currentRestaurant$
      .pipe(
        tap((rest: IRestaurant) => {
          if (this.currentView === 'local' && rest && this.idLocation !== rest.id) {
            this.idLocation = rest.id;
          }
          if (rest) {
            this.restaurant = rest;
            this.urlToken = rest.urlToken;
          } else {
            this.urlToken = null;
          }
        })
      )
      .subscribe();

    this.$platform.currentLocalOrder$
      .pipe(
        untilDestroyed(this),
        filter((order: IOrder) => !!order),
        tap((order: IOrder) => {
          this.currentOrder = order;
          if (this.currentOrder) {
            this.urlToken = this.currentOrder.company.urlToken;
          } else {
            this.urlToken = null;
          }
        })
      )
      .subscribe();
  }

  goTo(url: string): void {
    this.$layout.collapsed = true;
    this.router.navigateByUrl('/' + url);
  }

  share(): void {
    navigator
      .share({
        url: environment.domain + 'app/public/local/' + this.restaurant.urlToken,
        title: 'Kithoreca',
        text: this.restaurant.title,
      })
      .catch(() => {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = location.href;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.$toastr.success('Enlace copiado al portapapeles');
      });
  }

  collapsed(): boolean {
    return this.$layout.collapsed;
  }

  login(): void {
    this.$modal.open(ModalSessionSigninComponent, {
      centered: true,
    });
  }

  signout(): void {
    this.$oauth.signout();
  }
}
